import AppDataService from "./AppDataService";

const COMMON_BASE = 'SignIn'

export default class SignInDataService {
    static async signIn(signInData){
        return await AppDataService.post(COMMON_BASE, signInData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async logoutUser(){
        return await AppDataService.get('User/LogOut', {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async getSignInValidators() {
        return await AppDataService.get(`${COMMON_BASE}/GetValidator`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async forgotPasswordRequest(forgotPasswordData) {
        return await AppDataService.post(`${COMMON_BASE}/ForgotPassword`, forgotPasswordData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async validateResetToken(data) {
        return await AppDataService.post(`${COMMON_BASE}/ValidateToken`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async setPassword(setPasswordData) {
        return await AppDataService.post(`${COMMON_BASE}/SetPassword`, setPasswordData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async verifyTFACode(data) {
        return await AppDataService.post(`${COMMON_BASE}/TFALogin?verificationCode=${data}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async loginWThirdParty(data) {
        return await AppDataService.post(`${COMMON_BASE}/SSOSignIn`, data);
    }
    static async ssoIntegrationSignIn(data) {
        return await AppDataService.post(`${COMMON_BASE}/SSOIntegrationSignIn`, data);
    }
}